import { getSafeRandomNumber } from '@dealstack/frontend/shared/other/react/random';
import { yupResolver } from '@hookform/resolvers/yup';
import { Flex, Text } from '@mantine/core';
import { memo, ReactNode, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';
import styled from 'styled-components';
import * as yup from 'yup';

interface Props {
	children?: ReactNode;
}

const CaptchaProtectedRender = ({ children }: Props) => {
	const [captcha] = useState(generateNumericCaptcha());

	const captchaForm = useForm({
		mode: 'all',
		defaultValues: { captcha: '' },
		resolver: yupResolver(
			yup.object().shape({
				captcha: yup
					.string()
					.required()
					.test('is-captcha', 'Captcha is not valid', (value) => value === captcha),
			})
		),
	});

	function generateNumericCaptcha() {
		const randomNumber = getSafeRandomNumber();
		const sixCharactersNumber = randomNumber.toString().padStart(6, '0').slice(0, 6);
		return sixCharactersNumber;
	}

	const shouldRenderChild = useMemo(() => {
		return !!captchaForm.getValues('captcha') && !captchaForm.formState.errors.captcha;
	}, [captchaForm.formState, captchaForm.watch('captcha')]);

	return (
		<>
			<Flex direction="column" justify="center" align="center" gap="1rem">
				<Text>Please enter the captcha to continue</Text>

				<CaptchaBox>
					<Text size="B4Bold">{captcha}</Text>
				</CaptchaBox>
				<TextInput
					name="captcha"
					control={captchaForm.control}
					label="Enter captcha"
					size="md"
				/>
			</Flex>

			{shouldRenderChild && children}
		</>
	);
};

const CaptchaBox = styled.div`
	display: flex;
	width: fit-content;
	justify-content: center;
	align-content: center;
	text-align: center;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	border-radius: 4px;
	padding: 1rem;
`;
const _CaptchaProtectedRenderExport = memo(CaptchaProtectedRender);

export { _CaptchaProtectedRenderExport as CaptchaProtectedRender };
